<template>
  <v-autocomplete
      v-bind="$attrs"
      dense
      :items="itemList"
      return-object
      :multiple="multiple"
      :item-text="itemText"
      @change="onChange($event)"
      :error="error"
      :error-messages="error_message"
      :outlined="outlined"
      append-icon="mdi-refresh"
      @click:append="refreshList()"
      :loading="loading"
  >
    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import commonFunction from "@/commonFunction/commonFunction"

export default {
  name: 'BaseSelectFromTable',
  props: {
    // value: {default: null},
    dtoModel: {type: [String], default: null},
    storeName: {type: [String], default: null},
    itemText: {type: [String], default: null},
    multiple: {type: [Boolean], default: false},
    outlined: {type: [Boolean], default: true},
    filtersInit: {type: Array, default: () => []},
    property_state: {default: null},
    property_state_field_name: {default: null},
  },

  components: {},

  watch: {
    filtersInit: {
      handler(newValue, oldValue) {
        this.filtersListConst = JSON.parse(JSON.stringify(newValue))
        this.updateOptions()
      },
      deep: true
    },
  },

  computed: {
    ...commonFunction.mapDynamicGetters('storeName', ['getColumns']),
    ...commonFunction.mapDynamicFields('storeName', ['message_error', 'options', 'totalRecords',
      'options.page', 'itemList', 'loading', 'commandLoading', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'errorMessage', 'confirm_request', 'editedItem', 'filters', 'dialogItem', 'itemListCommon',
      'tableUpdateFromPercent', 'tableUpdateToPercent', 'tableLastUpdateFrom', 'tableLastUpdateTo', 'filtersListConst']),

    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
      else
        return null
    },
  },

  methods: {
    ...commonFunction.mapDynamicActions('storeName', ['openWebSocket', 'fetchItemList', 'fetchItem',
      'fetchSaveItemList', 'fetchAction',
      'fetchSaveItem', 'fetchActionSelectedItem', 'fetchActionItem', 'fetchRequest', 'fetchSaveEditedItem',
      'fetchSaveItem', 'fetchRemoveItem']),

    refreshList() {
      this.updateOptions()
    },

    updateOptions() {
      // console.log('updateOptions')
      if (!this.filters)
        this.filters = []
      this.filters = this.filters.filter(x => x.param_compare !== 'deleted')
      this.filters.push({param_compare: 'deleted', value: false})
      this.fetchItemList(this.dtoModel)
    },
    onChange(event) {
      // console.log('onChange', event)
      this.$emit('input', event)
    },

  }
  ,

  async mounted() {
    // console.log('mounted BaseTable', this.filtersInit)
    this.filtersListConst = JSON.parse(JSON.stringify(this.filtersInit))
    this.filters = [{param_compare: 'deleted', value: false}]
    if (!this.loading)
      this.updateOptions()
  }
  ,

  created() {
  }
  ,

  destroyed() {
  }
  ,

  beforeCreate() {
  }
  ,

  beforeDestroy() {
  }
  ,

  data() {
    return {
      selectedItem: this.value,
    }
  }
}

</script>

<style>
</style>

<i18n>
{
}
</i18n>
